import type { FunctionComponent } from "react";
import { CaretDownIcon } from "@App/Components/common/Icons";

type SelectFieldProps = {
  id: string;
  name: string;
  value: string | null;
  options: SelectFieldOption[];
  setValue: (value: string) => void;
};

type SelectFieldOption = {
  value: string;
  label: string;
};

export const SelectField: FunctionComponent<SelectFieldProps> = ({
  id,
  name,
  options,
  value,
  setValue,
}: SelectFieldProps) => {
  return (
    <div className="relative">
      <select
        id={id}
        name={name}
        className={
          "w-full appearance-none cursor-pointer border border-neutral-500 bg-white rounded shadow py-2 px-3"
        }
        value={value ?? ""}
        onChange={(e) => setValue(e.target.value)}
      >
        {options &&
          options.map((option: SelectFieldOption) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
      <CaretDownIcon className={"absolute top-4 w-3 h-3 right-3"} color={"neutral-500"} />
    </div>
  );
};
